export default __webpack_public_path__ + "fonts/design_img.57e6cc0c0ee713309f265e453fbfa526.png";